import React, { useEffect, useState } from "react";

import {
    FieldTimeOutlined,
    SaveOutlined,
    DeleteOutlined,
    ArrowLeftOutlined,
    UserOutlined
} from "@ant-design/icons";

import {
    canSyncRehabData,
    getActiveRehabProfileId,
    getRehabHistory,
    saveRehabData,
    deleteRehabData
} from "../../api/rehabTracking";

import {
    getPatientProfiles
} from "../../api/patientProfile";


export default function Tug() {

    const [seconds, setSeconds] =
        useState("");

    const [assistiveDevice, setAssistiveDevice] =
        useState("khong");

    const [note, setNote] =
        useState("");

    const [history, setHistory] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [activeProfile, setActiveProfile] =
        useState(null);


    /*
     * TÊN DỤNG CỤ HỖ TRỢ
     */
    const getAssistiveDeviceLabel = (value) => {

        switch (value) {

            case "khong":
                return "Không dùng dụng cụ hỗ trợ";

            case "gay":
                return "Gậy";

            case "nang":
                return "Nạng";

            case "khung":
                return "Khung tập đi";

            case "khac":
                return "Dụng cụ khác";

            default:
                return "";
        }
    };


    /*
     * FORMAT NGÀY GIỜ
     */
    const formatDateTime = (value) => {

        if (!value) {

            return {
                date: "",
                time: ""
            };
        }


        const dateObject =
            new Date(value);


        if (
            Number.isNaN(
                dateObject.getTime()
            )
        ) {

            return {
                date: "",
                time: ""
            };
        }


        return {

            date:
                dateObject.toLocaleDateString(
                    "vi-VN"
                ),

            time:
                dateObject.toLocaleTimeString(
                    "vi-VN",
                    {
                        hour: "2-digit",
                        minute: "2-digit"
                    }
                )
        };
    };


    /*
     * LOAD HỒ SƠ ĐANG CHỌN
     */
    const loadActiveProfile =
        async () => {

            try {

                if (!canSyncRehabData()) {

                    setActiveProfile(null);

                    return;
                }


                const activeId =
                    getActiveRehabProfileId();


                if (!activeId) {

                    setActiveProfile(null);

                    return;
                }


                const profiles =
                    await getPatientProfiles();


                const found =
                    Array.isArray(profiles)
                        ? profiles.find(
                            (item) =>
                                Number(
                                    item.profile_id
                                ) ===
                                Number(activeId)
                        )
                        : null;


                setActiveProfile(
                    found || null
                );

            } catch (error) {

                console.error(
                    "Không thể tải hồ sơ:",
                    error
                );


                setActiveProfile(null);
            }
        };


    /*
     * LOAD LỊCH SỬ TUG
     */
    const loadHistory =
        async () => {

            setLoading(true);

            setMessage("");


            try {

                if (!canSyncRehabData()) {

                    setHistory([]);

                    setMessage(
                        "Vui lòng đăng nhập để lưu và xem dữ liệu phục hồi chức năng."
                    );

                    return;
                }


                if (!getActiveRehabProfileId()) {

                    setHistory([]);

                    setMessage(
                        "Vui lòng chọn hồ sơ đang theo dõi trước khi sử dụng công cụ."
                    );

                    return;
                }


                const data =
                    await getRehabHistory(
                        "tug"
                    );


                const formatted =
                    Array.isArray(data)
                        ? data.map(
                            (item) => {

                                const tracking =
                                    item.tracking_data ||
                                    {};


                                const dateTime =
                                    formatDateTime(
                                        item.created_at
                                    );


                                return {

                                    id:
                                        item.health_tracking_id,

                                    seconds:
                                        Number(
                                            tracking.seconds ??
                                            0
                                        ),

                                    assistiveDevice:
                                        tracking.assistiveDevice ||
                                        tracking.assistive_device ||
                                        "khong",

                                    assistiveDeviceLabel:
                                        tracking.assistiveDeviceLabel ||
                                        getAssistiveDeviceLabel(
                                            tracking.assistiveDevice ||
                                            tracking.assistive_device ||
                                            "khong"
                                        ),

                                    note:
                                        tracking.note ||
                                        "",

                                    date:
                                        tracking.date ||
                                        dateTime.date,

                                    time:
                                        tracking.time ||
                                        dateTime.time
                                };
                            }
                        )
                        : [];


                setHistory(
                    formatted
                );

            } catch (error) {

                console.error(
                    "Không thể tải lịch sử TUG:",
                    error
                );


                setHistory([]);


                setMessage(
                    error?.message ||
                    "Không thể tải lịch sử TUG."
                );

            } finally {

                setLoading(false);
            }
        };


    /*
     * LOAD KHI MỞ TRANG
     */
    useEffect(() => {

        loadActiveProfile();

        loadHistory();

    }, []);


    /*
     * LƯU
     */
    const handleSave =
        async () => {

            if (!canSyncRehabData()) {

                alert(
                    "Vui lòng đăng nhập trước khi lưu dữ liệu."
                );

                return;
            }


            if (!getActiveRehabProfileId()) {

                alert(
                    "Vui lòng chọn hồ sơ đang theo dõi trước."
                );

                return;
            }


            if (
                seconds === "" ||
                seconds === null
            ) {

                alert(
                    "Vui lòng nhập thời gian TUG đã đo được."
                );

                return;
            }


            const secondsNumber =
                Number(seconds);


            if (
                Number.isNaN(secondsNumber) ||
                secondsNumber <= 0 ||
                secondsNumber > 600
            ) {

                alert(
                    "Vui lòng nhập thời gian hợp lệ."
                );

                return;
            }


            const now =
                new Date();


            const trackingData = {

                seconds:
                    secondsNumber,

                assistiveDevice,

                assistiveDeviceLabel:
                    getAssistiveDeviceLabel(
                        assistiveDevice
                    ),

                note:
                    note.trim(),

                date:
                    now.toLocaleDateString(
                        "vi-VN"
                    ),

                time:
                    now.toLocaleTimeString(
                        "vi-VN",
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        }
                    )
            };


            setSaving(true);

            setMessage("");


            try {

                await saveRehabData(
                    "tug",
                    trackingData
                );


                setSeconds("");

                setAssistiveDevice(
                    "khong"
                );

                setNote("");


                await loadHistory();


                setMessage(
                    "Đã lưu kết quả TUG."
                );

            } catch (error) {

                console.error(
                    "Không thể lưu TUG:",
                    error
                );


                setMessage(
                    error?.message ||
                    "Không thể lưu kết quả TUG."
                );

            } finally {

                setSaving(false);
            }
        };


    /*
     * XÓA
     */
    const handleDelete =
        async (id) => {

            const confirmed =
                window.confirm(
                    "Bạn có chắc muốn xóa kết quả TUG này?"
                );


            if (!confirmed) {
                return;
            }


            try {

                await deleteRehabData(
                    id
                );


                setHistory(
                    (current) =>
                        current.filter(
                            (item) =>
                                Number(item.id) !==
                                Number(id)
                        )
                );


                setMessage(
                    "Đã xóa kết quả TUG."
                );

            } catch (error) {

                console.error(
                    "Không thể xóa TUG:",
                    error
                );


                setMessage(
                    error?.message ||
                    "Không thể xóa kết quả TUG."
                );
            }
        };


    return (

        <div className="max-w-screen-xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">


            {/* QUAY LẠI */}

            <a
                href="/tienich/phuc-hoi-chuc-nang"
                className="inline-flex items-center text-emerald-600 font-semibold text-sm mb-4"
            >

                <ArrowLeftOutlined className="mr-2" />

                Phục hồi chức năng

            </a>


            {/* HEADER */}

            <div className="bg-gradient-to-r from-orange-500 to-amber-500 rounded-2xl px-5 py-5 md:p-8 text-white">

                <div className="flex items-center">

                    <div className="w-12 h-12 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">

                        <FieldTimeOutlined />

                    </div>


                    <div className="ml-4">

                        <p className="text-[11px] md:text-sm font-semibold opacity-90">

                            PHỤC HỒI CHỨC NĂNG

                        </p>


                        <h1 className="text-[25px] md:text-3xl font-bold">

                            Timed Up and Go

                        </h1>

                    </div>

                </div>


                <p className="text-[14px] md:text-base mt-4 opacity-90 leading-5 md:leading-normal max-w-3xl">

                    Ghi lại thời gian TUG đã được đo để theo dõi sự thay đổi khả năng vận động theo thời gian.

                </p>

            </div>


            {/* HỒ SƠ */}

            {activeProfile ? (

                <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-4">

                    <div className="flex items-center">

                        <div className="w-10 h-10 rounded-full bg-emerald-600 text-white flex items-center justify-center">

                            <UserOutlined />

                        </div>


                        <div className="ml-3">

                            <p className="text-[11px] font-bold text-emerald-700 uppercase">

                                Đang ghi dữ liệu cho

                            </p>


                            <p className="font-bold text-gray-900">

                                {activeProfile.profile_name}

                            </p>


                            {activeProfile.relationship && (

                                <p className="text-xs text-gray-500 mt-0.5">

                                    {activeProfile.relationship}

                                </p>

                            )}

                        </div>

                    </div>

                </div>

            ) : (

                <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-4">

                    <p className="font-semibold text-gray-800 text-sm">

                        Chưa chọn hồ sơ theo dõi

                    </p>


                    <p className="text-[13px] text-gray-600 mt-1">

                        Quay lại trang Phục hồi chức năng để chọn hoặc tạo hồ sơ trước khi lưu dữ liệu.

                    </p>


                    <a
                        href="/tienich/phuc-hoi-chuc-nang"
                        className="inline-block mt-2 text-emerald-600 font-semibold text-sm"
                    >

                        Chọn hồ sơ

                    </a>

                </div>

            )}


            {/* THÔNG BÁO */}

            {message && (

                <div className="bg-gray-50 border rounded-xl px-4 py-3 mt-4 text-[13px] text-gray-600">

                    {message}

                </div>

            )}


            {/* FORM */}

            <div className="bg-white border rounded-2xl p-4 md:p-6 mt-5">

                <h2 className="text-xl md:text-2xl font-bold text-gray-800">

                    Ghi kết quả TUG

                </h2>


                <p className="text-gray-500 text-sm mt-1">

                    Nhập thời gian đã đo được trong lần đánh giá này.

                </p>


                {/* THỜI GIAN */}

                <div className="mt-5">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Thời gian thực hiện

                    </label>


                    <div className="relative">

                        <input
                            type="number"
                            min="0.1"
                            max="600"
                            step="0.1"
                            value={seconds}
                            onChange={(e) =>
                                setSeconds(
                                    e.target.value
                                )
                            }
                            placeholder="Ví dụ: 12.5"
                            className="w-full h-12 border rounded-xl px-3 pr-16 outline-none focus:border-orange-500"
                        />


                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm">

                            giây

                        </span>

                    </div>

                </div>


                {/* DỤNG CỤ HỖ TRỢ */}

                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Dụng cụ hỗ trợ khi đánh giá

                    </label>


                    <select
                        value={assistiveDevice}
                        onChange={(e) =>
                            setAssistiveDevice(
                                e.target.value
                            )
                        }
                        className="w-full h-12 border rounded-xl px-3 bg-white outline-none focus:border-orange-500"
                    >

                        <option value="khong">
                            Không dùng dụng cụ hỗ trợ
                        </option>

                        <option value="gay">
                            Gậy
                        </option>

                        <option value="nang">
                            Nạng
                        </option>

                        <option value="khung">
                            Khung tập đi
                        </option>

                        <option value="khac">
                            Dụng cụ khác
                        </option>

                    </select>

                </div>


                {/* GHI CHÚ */}

                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Ghi chú

                        <span className="font-normal text-gray-400 ml-1">

                            (không bắt buộc)

                        </span>

                    </label>


                    <textarea
                        value={note}
                        onChange={(e) =>
                            setNote(
                                e.target.value
                            )
                        }
                        placeholder="Ví dụ: cần giám sát, bước đi chậm..."
                        rows={3}
                        className="w-full border rounded-xl px-3 py-3 outline-none focus:border-orange-500 resize-none"
                    />

                </div>


                {/* LƯU */}

                <button
                    type="button"
                    onClick={
                        handleSave
                    }
                    disabled={
                        saving ||
                        !activeProfile
                    }
                    className="w-full mt-5 h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                >

                    <SaveOutlined className="mr-2" />

                    {saving
                        ? "Đang lưu..."
                        : "Lưu kết quả TUG"
                    }

                </button>

            </div>


            {/* LỊCH SỬ */}

            <div className="mt-7">

                <h2 className="text-xl md:text-2xl font-bold text-gray-800">

                    Lịch sử TUG

                </h2>


                <p className="text-gray-500 text-sm mt-1">

                    Các kết quả TUG của hồ sơ đang được chọn.

                </p>


                {loading ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <p className="text-sm text-gray-500">

                            Đang tải dữ liệu...

                        </p>

                    </div>

                ) : history.length === 0 ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <FieldTimeOutlined className="text-3xl text-gray-300" />


                        <p className="font-semibold text-gray-700 mt-3">

                            Chưa có kết quả

                        </p>


                        <p className="text-sm text-gray-500 mt-1">

                            Kết quả TUG của hồ sơ này sẽ xuất hiện tại đây.

                        </p>

                    </div>

                ) : (

                    <div className="space-y-3 mt-4">

                        {history.map(
                            (item) => (

                                <div
                                    key={item.id}
                                    className="bg-white border rounded-2xl p-4"
                                >

                                    <div className="flex items-start justify-between">

                                        <div className="flex-1 pr-3">

                                            <div className="flex items-end">

                                                <p className="text-3xl font-bold text-orange-600">

                                                    {item.seconds}

                                                </p>


                                                <span className="text-sm text-gray-400 ml-1 mb-1">

                                                    giây

                                                </span>

                                            </div>


                                            <p className="text-[13px] text-gray-600 mt-2">

                                                {item.assistiveDeviceLabel}

                                            </p>


                                            <p className="text-xs text-gray-400 mt-1">

                                                {item.time} - {item.date}

                                            </p>


                                            {item.note && (

                                                <div className="bg-gray-50 rounded-xl px-3 py-2 mt-3">

                                                    <p className="text-[13px] text-gray-500">

                                                        {item.note}

                                                    </p>

                                                </div>

                                            )}

                                        </div>


                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleDelete(
                                                    item.id
                                                )
                                            }
                                            className="w-10 h-10 rounded-xl bg-red-50 text-red-500 flex items-center justify-center flex-shrink-0"
                                            aria-label="Xóa kết quả TUG"
                                        >

                                            <DeleteOutlined />

                                        </button>

                                    </div>

                                </div>

                            )
                        )}

                    </div>

                )}

            </div>


            {/* LƯU Ý */}

            <div className="bg-orange-50 border border-orange-100 rounded-2xl p-4 mt-7">

                <p className="font-semibold text-gray-800 text-sm">

                    Lưu ý

                </p>


                <p className="text-[13px] text-gray-600 leading-5 mt-1">

                    Công cụ này dùng để ghi lại thời gian TUG đã được đo trong một lần đánh giá.

                </p>


                <p className="text-[13px] text-gray-500 leading-5 mt-2">

                    Việc đánh giá khả năng đứng và đi có thể có nguy cơ té ngã.
                    Website không hướng dẫn người dùng tự thực hiện bài kiểm tra và không thay thế đánh giá trực tiếp của nhân viên y tế.

                </p>

            </div>

        </div>
    );
}